import type { I18nT } from "@lib/dashboardI18n";

export enum ErrorCode {
  FailedToSendEmail = "FAILED_TO_SEND_EMAIL", // Failed to send email, Please try again
  FailedToValidateEmailCode = "FAILED_TO_VALIDATE_EMAIL_CODE", // Failed to validate email code, Please provide a valid code
  FailedToSendSms = "FAILED_TO_SEND_SMS", // Failed to send SMS, Please try again
  FailedToValidateSmsCode = "FAILED_TO_VALIDATE_SMS_CODE", // Failed to validate SMS code, Please provide a valid code
  InvalidEmail = "INVALID_EMAIL", // Invalid email, Please provide a valid email
  ReachedMaxSendAttempts = "REACHED_MAX_SEND_ATTEMPTS", // Reached max send attempts, Please try again later
  InvalidCodeFormat = "INVALID_CODE_FORMAT", // Invalid code format, Please provide a valid code
  MaxCheckAttemptsError = "MAX_CHECK_ATTEMPTS_ERROR", // Max check attempts error, Please try again later
  InvalidPhoneNumber = "INVALID_PHONE_NUMBER", // Invalid phone number, Please provide a valid phone number
  InvalidParams = "INVALID_PARAMS", // Invalid params
  InternalError = "INTERNAL_ERROR", // Internal error
  BlockedCountry = "BLOCKED_COUNTRY", // This country is not supported
  VerificationTimeout = "VERIFICATION_TIMEOUT", // Verification timeout
  Unknown = "UNKNOWN", // Something went wrong, Please try again
  BadRequest = "BAD_REQUEST",
  Unauthorized = "UNAUTHORIZED",
  Forbidden = "FORBIDDEN",
}

const errorMessages = (t: I18nT<"free-trial-registration">): Record<ErrorCode, string> => ({
  [ErrorCode.FailedToSendEmail]: t(
    "failed-to-send-email",
    "There was an error during verification, please try again."
  ),
  [ErrorCode.FailedToValidateEmailCode]: t(
    "failed-to-validate-email-code",
    "Incorrect code. Re-enter the 6-digit code or resend verification code."
  ),
  [ErrorCode.FailedToSendSms]: t("failed-to-send-sms", "Failed to send SMS, Please try again."),
  [ErrorCode.FailedToValidateSmsCode]: t(
    "failed-to-validate-sms-code",
    "Failed to validate SMS code, Please provide a valid code"
  ),
  [ErrorCode.InvalidEmail]: t("invalid-email", "Invalid email, Please provide a valid email."),
  [ErrorCode.ReachedMaxSendAttempts]: t("reached-max-send-attempts", "Too many verification codes have been sent."),
  [ErrorCode.InvalidCodeFormat]: t(
    "invalid-code-format",
    "Incorrect code. Re-enter the 6-digit code or resend verification code"
  ),
  [ErrorCode.MaxCheckAttemptsError]: t(
    "max-check-attempts-error",
    "Max check attempts error, Please try again later"
  ),
  [ErrorCode.InvalidPhoneNumber]: t(
    "invalid-phone-number",
    "Invalid phone number, Please provide a valid phone number"
  ),
  [ErrorCode.InvalidParams]: t("twilio-error", "There was an error during verification, please try again."),
  [ErrorCode.InternalError]: t("internal-error", "There was an error during verification, please try again."),
  [ErrorCode.BlockedCountry]: t("blocked-country", "Unable to trial Braze in the selected country"),
  [ErrorCode.VerificationTimeout]: t(
    "verification-timeout",
    "This code has expired. Please resend code and try again."
  ),
  [ErrorCode.Unknown]: t("unknown-error", "Something went wrong, Please try again!"),
  [ErrorCode.BadRequest]: t("bad-request", "Sorry, we are unable to create your account at the moment."),
  [ErrorCode.Unauthorized]: t("unauthorized", "Something went wrong, Please try again!"),
  [ErrorCode.Forbidden]: t("forbidden", "Something went wrong, Please try again!"),
});

export const getErrorMessage = (t: I18nT<"free-trial-registration">, errorCode: ErrorCode) =>
  errorMessages(t)[errorCode];
